import { z } from "zod";

export * from "./app-feedback";
export * from "./auth";
export * from "./codegen";
export * from "./events";
export * from "./feedback";
export * from "./filesystem";
export * from "./tasks";

export const ApiErrorSchema = z.object({
  error: z.object({
    message: z.string(),
    code: z.string(),
  }),
});

export const ApiResponseSchema = <T extends z.ZodType>(schema: T) =>
  z.object({
    data: schema,
  });
